import React from 'react';
import { createUseStyles } from 'react-jss';
import { ManifestTableRowFragment } from './ManifestTableRowFragment';

const useStyles = createUseStyles({
  thead__tr: {
    backgroundColor: 'var(--fifth-color)',
    '& th': {
      // Styles applied to all <th> elements inside .thead__tr
      userSelect: 'none',
      cursor: 'pointer',
      whiteSpace: 'nowrap',
      textAlign: 'left',
      padding: 10,
    },
    '& th.th__min': {
      // Additional styling for specific th elements
      width: '1px',
    },
  },
  manifestTable: {
    borderSpacing: '0',
    width: '100%',
  },
});

export const ManifestTable = ({ manifests }) => {
  const classes = useStyles();

  return (
    <table className={classes.manifestTable}>
      <thead>
        <tr className={classes.thead__tr}>
          <th className='th__min'>Date</th>
          <th>Name</th>
          <th>Project</th>
          <th>Reference</th>
          <th>Sender</th>
          <th>Recipient</th>
          <th className='th__min'>State</th>
        </tr>
      </thead>

      <tbody>
        {manifests?.map((row) => (
          <ManifestTableRowFragment key={row.id} manifest={row}></ManifestTableRowFragment>
        ))}
      </tbody>
    </table>
  );
};
